import { IAccount } from "@core/account/interface";
import * as dasha from "@dasha.ai/sdk/web";
import { makeAutoObservable, runInAction } from "mobx";

export class ApplicationStore {
  private readonly account: IAccount;
  public Loading: boolean;
  public ApplicationNames: string[];
  constructor(account: IAccount) {
    this.account = account;
    this.ApplicationNames = [];
    makeAutoObservable(this);
  }

  public TryReload() {
    if (this.ApplicationNames.length === 0 && !this.Loading) {
      this.Reload();
    }
  }

  public async GetAgents() {
    const take = 1000;
    var skip = 0;
    const a = this.account.connect();
    var agents: dasha.applications.AgentInfo[] = [];

    while (true) {
      const fetched = await dasha.applications.getAgents(skip, take, { account: a });
      agents.push(...fetched);
      skip += take;
      if (fetched.length < take) {
        break;
      }
    }
    return agents;  
  }

  private Reload() {
    this.Loading = true;
    this.GetAgents().then((agents) => {
      runInAction(() => {
        this.ApplicationNames = Array.from(new Set(agents.map((x) => x.name)));
      });
    }).finally(() => {
      runInAction(() => {
        this.Loading = false;
      });
    });
  }
}
